var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 64,
    rx: 10,
    fill: "#56AB9F",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1 32.938L26.19 31.19 14 20.068v24.027l9.799-7.76 4.3-3.396zM34.922 38.112a.78.78 0 01-.582.226h-.161a1.003 1.003 0 01-.42-.194l-4.366-4.042-7.956 6.306L15.617 45h37.512L39.32 34.102l-4.398 4.01z",
    fill: "#56AB9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.008 32.356L34.34 36.3l4.366-3.978L53.324 19H15.358l14.65 13.356zM49.313 24.983l-8.7 7.955 14.132 11.156v-24.06l-5.432 4.949z",
    fill: "#56AB9F"
  })));
}
export default SvgEnvelopeIconSvg;